import React from "react";
import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
      <h6 className="fw-semibold mb-0" style={{textTransform:'capitalize'}}>
        <p style={{ cursor: "pointer", display: "inline" }} onClick={() => window.history.back()}>
          <Icon  icon="solar:arrow-left-linear"/>
        </p>
         {pathnames.length === 2 && pathnames[pathnames.length-2].replace(/-/g, ' ') === 'invoice preview' ? pathnames[pathnames.length-2].replace(/-/g, ' ') : ''} {pathnames.length > 0 && "  " + pathnames[pathnames.length - 1].replace(/-/g, ' ')}
      </h6>

      <ul className="d-flex align-items-center gap-2">
        <li className="fw-medium">
          <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
            Dashboard
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          return (
            <React.Fragment key={to}>
              <li> - </li>
              <li className="fw-medium" style={{textTransform:'capitalize'}}>
                {isLast ? (
                  <span>{value.replace(/-/g, " ")}</span>
                ) : (
                  <Link to={to} className="hover-text-primary">
                    {value.replace(/-/g, " ")}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default Breadcrumb;
